import { ElementType } from 'react';

import { useNullableContext } from '~/common/contexts/nullableContext';
import { TenantAsset } from '~/core/shared/assets';
import { AssetRepositoryContext } from '../../AssetRepositoryContext';

export const useAsset = (
  key: TenantAsset,
  fallback?: ElementType,
): ElementType | undefined => {
  const { assetRepository } = useNullableContext(
    AssetRepositoryContext,
    'useAsset must be used within an AssetRepositoryProvider',
  );

  return assetRepository[key] ?? fallback;
};
